const SHOULD_PERSIST_GROUPS_KEY = "persistGroupChanges";
const PERSISTED_GROUPS_KEY = "persistedGroups";

export { SHOULD_PERSIST_GROUPS_KEY, PERSISTED_GROUPS_KEY };
